module.exports = __webpack_public_path__ + "img/BN-Logo.8f0689d7.png";